import { identify, track } from "./analytics.js"

/*
 * The wishlist (src/wishlist.erb): ideas for the app, best first. People on
 * the waitlist vote them up or down and add their own (/api/ideas,
 * worker/index.js). Who you are is your waitlist code: from the link in our
 * emails (?me=CODE), or kept on this device since you joined (bo:spot, as in
 * spot.js). Without one, the list is read-only.
 */

const OWN = "bo:spot"
const CODE = /^[A-Z2-9]{6}$/

const root = document.querySelector("[data-wishlist]")
if (root) start()

function stored() {
  try {
    return localStorage.getItem(OWN)
  } catch {
    return null
  }
}

function myCode() {
  const params = new URLSearchParams(location.search)
  const fromLink = (params.get("me") || "").toUpperCase()
  if (CODE.test(fromLink)) {
    try {
      localStorage.setItem(OWN, fromLink)
    } catch {
      /* private mode: this visit still works */
    }
    // The code stays out of the address bar, so a shared screenshot or link doesn't vote as you.
    params.delete("me")
    history.replaceState(null, "", location.pathname + (params.size ? `?${params}` : "") + location.hash)
    return fromLink
  }
  const kept = (stored() || "").toUpperCase()
  return CODE.test(kept) ? kept : null
}

const esc = (v) => String(v).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c])

async function start() {
  const code = myCode()
  const list = root.querySelector("[data-wish-list]")
  const form = root.querySelector("[data-wish-form]")
  const msg = root.querySelector("[data-wish-msg]")
  let ideas = []
  let member = false
  let justAdded = null

  const draw = () => {
    list.innerHTML = ideas
      .map((i) => {
        const tag = i.yours ? "Your idea" : i.fresh && i.parent ? "New" : i.parent ? "From a parent" : ""
        return `<li class="wish-row${i.id === justAdded ? " is-new" : ""}" data-id="${i.id}">
  <div class="wish-vote" role="group" aria-label="Vote">
    <button type="button" class="wish-btn${i.vote === 1 ? " is-on" : ""}" data-vote="1" aria-pressed="${i.vote === 1}" aria-label="Vote up" ${member ? "" : "disabled"}>▲</button>
    <span class="wish-score" aria-label="Score ${i.score}">${i.score || ""}</span>
    <button type="button" class="wish-btn is-down${i.vote === -1 ? " is-on" : ""}" data-vote="-1" aria-pressed="${i.vote === -1}" aria-label="Vote down" ${member ? "" : "disabled"}>▼</button>
  </div>
  <div class="wish-text"><p>${esc(i.title)}</p>${tag ? `<span class="wish-tag">${tag}</span>` : ""}</div>
</li>`
      })
      .join("")
  }

  const show = (data) => {
    // Best first when the page opens; after that rows keep their place, so
    // nothing jumps away from your finger. A new idea goes on top.
    const place = new Map(ideas.map((i, n) => [i.id, n]))
    ideas = place.size ? [...data.ideas].sort((a, b) => (place.get(a.id) ?? -1) - (place.get(b.id) ?? -1)) : data.ideas
    member = data.member
    form.hidden = !member
    root.querySelector("[data-wish-join]").hidden = member
    draw()
  }

  const send = async (path, body) => {
    const res = await fetch(path, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ code, ...body }) })
    const out = await res.json().catch(() => ({}))
    if (!res.ok) throw new Error(out.error || "Something went wrong. Try again.")
    return out
  }

  try {
    const res = await fetch(`/api/ideas${code ? `?code=${code}` : ""}`)
    if (!res.ok) throw new Error()
    show(await res.json())
    if (member) identify(code)
    track("wishlist_viewed", { member })
  } catch {
    list.innerHTML = `<li class="wish-row text-muted">Couldn't load the ideas. Try again in a moment.</li>`
    return
  }

  list.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-vote]")
    if (!btn || !member) return
    const idea = ideas.find((i) => i.id === Number(btn.closest("[data-id]").dataset.id))
    const pick = Number(btn.dataset.vote)
    const value = idea.vote === pick ? 0 : pick
    // Straight away on screen; the server's answer (and order) follows.
    const was = idea.vote
    idea.score += value - was
    idea.vote = value
    justAdded = null
    draw()
    try {
      show(await send("/api/ideas/vote", { id: idea.id, value }))
      track("idea_voted", { value, idea: idea.title })
    } catch (err) {
      idea.score -= value - was
      idea.vote = was
      draw()
      msg.textContent = err.message
    }
  })

  form.addEventListener("submit", async (e) => {
    e.preventDefault()
    const field = form.elements.title
    const button = form.querySelector("button")
    button.disabled = true
    msg.textContent = ""
    try {
      const out = await send("/api/ideas", { title: field.value })
      justAdded = out.added
      show(out)
      field.value = ""
      msg.textContent = "Added. Thank you!"
      track("idea_added")
      list.querySelector(".is-new")?.scrollIntoView({ behavior: "smooth", block: "center" })
    } catch (err) {
      msg.textContent = err.message
    } finally {
      button.disabled = false
    }
  })
}
